import { useNavigate, useSearchParams } from "react-router-dom";
import AuthCard from "../../components/auth/AuthCard";
import SignUpInfoFields from "../../components/auth/signup/SignUpInfoFields";
import SignUpPasswordFields from "../../components/auth/signup/SignUpPasswordFields";
import SignUpComplete from "../../components/auth/signup/SignUpComplete";
import { useEffect, useState } from "react";
import { signup } from "../../api/auth";
import useSignup from "../../hooks/useSignup";

export default function SignUp() {
    const STEP = { INFO: "info", PASSWORD: "password", COMPLETE: "complete" };
    const [infoValid, setInfoValid] = useState(false);
    const [passwordValid, setPasswordValid] = useState(false);   // 다음 단계용
    const [params, setParams] = useSearchParams();
    const step = params.get("step") || STEP.INFO;
    const go = (next) => next ? setParams({ step: next }) : setParams();
    const navigate = useNavigate();

    const [infoData, setInfoData] = useState(null);   // 이름·주민번호·전화
    const [pwdData, setPwdData] = useState(null);   // 패스워드
    const [error, setError] = useState("");
    const signupMutation = useSignup();

    const handleInfoNext = (data) => {
        // console.log("INFO 단계 값:", data);
        setInfoData(data);          // { name, rrn_front, rrn_back1, phone, ... }
        go(STEP.PASSWORD);
    };

    const handlePasswordNext = async (data) => {
        // console.log("INFO 단계 값:", data);
        setPwdData(data);           // { password }
        try {
            await signup({           // ❶ 한 번에 백엔드로 전송
                ...infoData,
                ...data,               // password
                consent_personal: infoData.consent_personal,
                consent_tos: infoData.consent_tos,
                consent_marketing: infoData.consent_marketing,
            });
            go(STEP.COMPLETE);       // ❷ 성공 → 완료 화면
        } catch (e) {
            setError(e.detail ?? "회원가입 실패");
        }
    };


    useEffect(() => {
        // 사용자가 중간 step으로 진입하려는 경우 차단
        if (step === STEP.PASSWORD && !infoValid) {
            go(STEP.INFO);
        } else if (step === STEP.COMPLETE && (!infoValid || !passwordValid)) {
            go(STEP.INFO);
        }
    }, [step, infoValid, passwordValid]);




    return (
        <main className="h-[var(--app-height)] flex items-center justify-center px-7 font-suit">
            <AuthCard title="회원가입" onClose={() => navigate(-1)} className="h-full w-full">
                {/* 중앙 콘텐츠 */}
                <div className="flex-1 overflow-y-auto scrollbar-hide">
                    {/* 단계별 컴포넌트 렌더링 */}
                    {step === STEP.INFO &&
                        <SignUpInfoFields
                            onNext={handleInfoNext}
                            onValidChange={setInfoValid}
                        />}

                    {step === STEP.PASSWORD && (
                        <SignUpPasswordFields
                            onBack={() => go(STEP.INFO)}
                            onNext={handlePasswordNext}
                            onValidChange={setPasswordValid}
                        />
                    )}
                    {step === STEP.COMPLETE && <SignUpComplete />}

                </div>

                {/* 하단 고정 버튼 */}
                {/* {footer && (
                    <div className="py-6">
                        <button
                            onClick={footer.action}
                            disabled={footer.disabled || signupMutation.isPending}
                            className="w-full py-3 rounded-xl bg-[#5F9BFF] text-white
                            disabled:bg-[#F1F1F1] disabled:text-gray-400">
                            {signupMutation.isPending ? "전송 중..." : footer.label}
                        </button>
                    </div>
                )} */}

            </AuthCard>
        </main>
    );
}
